import React from "react";

import Button from "../../../common/components/Button";
import Context from "../../../context/Context";
import DateTime from "./DateTime";
import Duration from "./Duration";
import EsriReservationSchema from "../More/Actions/BookWorkspace/WorkspaceReservation/EsriReservationSchema";
import FieldNames from "../../../aiim/datasets/FieldNames";
import IcsLink from "./IcsLink";
import ItemReference from "../../../aiim/base/ItemReference";
import Loader from "calcite-react/Loader/Loader";
import ModalController from "../../../common/components/Modal/ModalController";
import Schedule from "./Schedule";
import TextField from "calcite-react/TextField";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as component from "../../util/component";
import * as dateUtil from "../Events/dateUtil";
import * as ics from "../Events/ics";
import CalendarSelector from "../../../util/CalendarSelector";
import { makeEventInfo } from "../../../util/calendarUtil";
import { isNetworkError } from "../../../util/networkUtil";

//import CalIcon from "calcite-ui-icons-react/CalendarIcon";
import CheckCircleIcon from "calcite-ui-icons-react/CheckCircleIcon"
import ClockIcon from "calcite-ui-icons-react/ClockIcon";
import PinIcon from "calcite-ui-icons-react/PinIcon";
import UserIcon from "calcite-ui-icons-react/UserIcon";

export default class Book extends React.Component {

  componentId;
  durationComponent;
  startComponent;
  endComponent;

  constructor(props) {
    super(props);
    this.componentId = component.nextId("book-");
    this.state = component.newState({
      title: null,
      titleError: null,
      description: null,
      working: false
    });
  }

  componentDidMount() {
    if (this.props.onMount) this.props.onMount(this);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  render() {
    const i18n = Context.instance.i18n;
    const when = Object.assign({},this.props.criteria.when);

    const onPartChanged = (c,type,dateMoment,timeMoment,prev) => {
      let c2 = this.endComponent;
      if (c === this.endComponent) c2 = this.startComponent;
      c2.whenAssociatedPartChanged(c,type,dateMoment,timeMoment,this.durationComponent,prev);
    };

    let loader;
    if (this.state.working) {
      loader = (
        <div style={{position:"absolute",width:"80%",top:"100px"}}>
          <Loader sizeRatio={1} style={{marginTop: "3rem"}} />
        </div>
      );
    }

    return (
      <div className="i-filter-form">
        {loader}
        <div style={{marginBottom: "1.2rem"}}>
          <TextField type="text"
            placeholder={i18n.meetingRooms.book.title}
            error={!!this.state.titleError}
            title={this.state.titleError}
            onChange={evt => {
              let v = evt.target.value;
              this.setState({
                title: v,
                titleError: null
              });
            }}
          />
        </div>
        <div>
          <Duration
            formKey={this.componentId}
            duration={when.duration}
            criteria={when}
            onMount={c => this.durationComponent = c}/>
        </div>
        <div>
          <DateTime
            formKey={this.componentId}
            duration={when.duration}
            criteria={when}
            label={i18n.meetingRooms.start}
            isStart={true}
            date={when.start.date}
            onMount={c => this.startComponent = c}
            onPartChanged={onPartChanged} />
        </div>
        <div>
          <DateTime
            formKey={this.componentId}
            duration={when.duration}
            criteria={when}
            label={i18n.meetingRooms.end}
            isEnd={true}
            date={when.end.date}
            startDate={when.start.date}
            onMount={c => this.endComponent = c}
            onPartChanged={onPartChanged} />
        </div>
        <div>
          <div>{i18n.meetingRooms.book.location}</div>
          <div
            style={{
              marginTop: "0.3rem",
              padding: "0.5rem",
              border: "1px solid #a9a9a9"
            }}>
            {this.props.item.name}
          </div>
        </div>
        {/*
        <div style={{marginTop: "1.2rem"}}>
          <div>{i18n.meetingRooms.book.description}</div>
          <div>
            <TextField type="textarea"
              onChange={evt => {
                let v = evt.target.value;
                this.setState({
                  description: v
                });
              }}
            />
          </div>
        </div>
        */}
      </div>
    );
  }

  setStart(m,roundedMillis) {
    this.startComponent.setFromMoment(m,roundedMillis);
  }

  setWhen(when) {
    this.durationComponent.setWhen(when.duration);
    this.startComponent.setWhen(when.start.date,when.duration);
    this.endComponent.setWhen(when.end.date,when.duration);
  }

  validate(criteria,whenOnly) {
    const i18n = Context.instance.i18n;
    let ok = true;
    let when = {
      duration: null,
      start: {},
      end: {}
    };

    let title = this.state.title;
    if (typeof title !== "string") title = "";
    title = title.trim();
    if (title.length === 0 && !whenOnly) {
      ok = false;
      this.setState({
        titleError: i18n.general.valueRequired
      })
    }

    let desc = this.state.description;
    if (typeof desc === "string") desc = desc.trim();

    if (ok) ok = this.durationComponent.validate(when);
    if (ok) ok = this.startComponent.validate(when.start);
    if (ok) ok = this.endComponent.validate(when.end);
    if (ok) {
      if (when.start.date && when.end.date &&
         (when.start.date <= when.end.date)) {
        // also check isRequired?
      }
    }
    if (ok && when.start.date && when.end.date && when.duration) {
      if (when.duration === "allDay") {
        let dt1 = dateUtil.toStartOfDay(new Date(when.start.date));
        let dt2 = dateUtil.toEndOfDay(new Date(when.end.date));
        //let d = dateUtil.getDurationKey(dt1,dt2);
        when.start.date = dt1.getTime();
        when.end.date = dt2.getTime();
        //when.duration = d;
      } else {
        let dt1 = new Date(when.start.date);
        let dt2 = new Date(when.end.date);
        let d = dateUtil.getDurationKey(dt1,dt2);
        when.duration = d;
      }
    }
    if (ok) {
      criteria.title = title;
      criteria.description = desc;
      criteria.when = when;
    }
    return ok;
  }

  static bookWorkspace(task) {
    task.bookComponent.setState({working: true});
    const i18n = Context.instance.i18n;

    let itemRef;
    const ds = Context.instance.aiim.datasets.units;
    const source = ds && ds.getSource();
    const sr = source && source.makeSearchResult(null,task.item.feature);
    if (sr) {
      itemRef = new ItemReference();
      itemRef.fromSearchResult(source.key,sr)
    }

    const when = task.criteria.when;
    const params = {
      title: task.criteria.title,
      description: task.criteria.description,
      noAutoDescription: true,
      unit: task.item.feature,
      checkIn: when.start.date,
      checkOut: when.end.date,
      allDay: (when.duration === "allDay"),
      item: itemRef
    };
    if (params.allDay) {
      params.checkIn = dateUtil.toStartOfDay(new Date(params.checkIn)).getTime();
      params.checkOut = dateUtil.toEndOfDay(new Date(params.checkOut)).getTime();
    }

    let r = Context.instance.aiim.datasets.reservations;
    let unitId = task.item.unitId;
    let fromDate = new Date(params.checkIn);
    let toDate = new Date(params.checkOut);

    let sys = EsriReservationSchema.getInstance();
    let accessToken = null;

    r.queryUnitSchedule(unitId,fromDate,toDate).then(result => {
      //console.log("queryUnitSchedule.result",result)
      task.available = false;
      if (result && result.reserved && result.reserved.length === 0) {
        task.available = true;
      }
      if (task.available) {
        return sys.bookWorkspace(accessToken,params);
      } else {
        let err = new Error("Not available.");
        err.code = "__notAvailable__";
        throw err;
      }

    }).then(result => {
      task.reservation = result.reservation;
      return Book.makeIcsInfo(task,result.reservation);

    }).then(() => {
      const reservationsDataset = Context.getInstance().aiim.datasets.reservations;
      const unitsDataset = Context.getInstance().aiim.datasets.units;
      const calendarParams = makeEventInfo(reservationsDataset, task.reservation, unitsDataset, task.item.feature);
      
      const lib = Context.instance.lib
      const levels = Context.instance.aiim.datasets.levels;
      let attr = task.reservation.attributes;
      let name = aiimUtil.getAttributeValue(attr,FieldNames.TITLE);
      let dtFrom = new Date(aiimUtil.getAttributeValue(attr,FieldNames.START_TIME));
      let dtTo = new Date(aiimUtil.getAttributeValue(attr,FieldNames.END_TIME));
      let fullName = aiimUtil.getAttributeValue(attr,FieldNames.RESERVED_FOR_FULL_NAME);
      let levelId = aiimUtil.getAttributeValue(attr,FieldNames.LEVEL_ID);
      let unit = aiimUtil.getAttributeValue(attr,FieldNames.UNIT_NAME);
      let from = lib.dojo.locale.format(dtFrom,{formatLength:"short"});
      let to = lib.dojo.locale.format(dtTo,{formatLength:"short"});
      let range = i18n.meetingRooms.rangePattern.replace("{fromDate}",from).replace("{toDate}",to);
      let orgBy = i18n.meetingRooms.organizedBy.replace("{person}",fullName);
      let fl;
      let ld = levels && levels.getLevelData(levelId);
      if (ld) {
        let p = i18n.meetingRooms.levelAndFacility;
        fl = p.replace("{levelName}",ld.levelName).replace("{facilityName}",ld.facilityName);
      }
      // let icsNode, icsInfo = task.icsInfo;
      // if (icsInfo && typeof icsInfo.href === "string") {
      //   icsNode = <IcsLink icsInfo={icsInfo} />
      // }
      // const addToCalendarButton = (
      //   <button
      //     className={"i-button"}
      //   >
      //     {i18n.events.details.addToCalendar}
      //   </button>
      // );


      let content = (
        <MeetingBookingConfirmed
          name={name}
          range={range}
          unit={unit}
          fl={fl}
          orgBy={orgBy}
          calendarParams={calendarParams}
        />
      );

      task.controller.close();
      const c = new ModalController();
      c.show({
        title: i18n.meetingRooms.book.newMeeting,
        className: "i-modal-confirm i-modal-transparent",
        showOKCancel: false
      },content);

    }).catch(ex => {
      console.error(ex);
      task.status.executing = false;
      task.bookComponent.setState({working: false});

      let msg = (ex && ex.message) || "";
      let msgTitle = i18n.meetingRooms.book.couldNotBookTitle;
      if (ex && ex.code === "__notAvailable__") {
        msgTitle = i18n.meetingRooms.book.roomUnavailableTitle;
        msg = i18n.meetingRooms.book.roomUnavailable;
        msg = msg.replace("{unitName}",task.item.name);
      } else if (ex && isNetworkError(ex.message)) {
        msg = i18n.meetingRooms.issues.m1;
      }

      ModalController.confirm({
        isError: true,
        title: msgTitle,
        message: msg,
        submessage: null,
        hideCancel: true
      });

    })
  }

  static makeIcsInfo(task,reservation) {
    const promise = new Promise((resolve,reject) => {
      let feature = task.item.feature;
      let filename = "reservation.ics";
      let attr = reservation.attributes;
      let info = {
        name: aiimUtil.getAttributeValue(attr,FieldNames.TITLE),
        description: aiimUtil.getAttributeValue(attr,FieldNames.DESCRIPTION),
        location: aiimUtil.getAttributeValue(attr,FieldNames.UNIT_NAME),
        date_start: new Date(aiimUtil.getAttributeValue(attr,FieldNames.START_TIME)),
        date_end: new Date(aiimUtil.getAttributeValue(attr,FieldNames.END_TIME)),
        geo: null,
        geometry: feature && feature.geometry
      };
      ics.makeIcsInfo(info,filename).then(icsInfo => {
        task.icsInfo = icsInfo;
        resolve();
      }).catch(ex => {
        console.error("Error generating .ics file:",ex);
        resolve();
      });
    });
    return promise;
  }

  static scheduleClicked(task) {
    const i18n = Context.instance.i18n;
    const roomItem = {
      unitId: task.item.unitId,
      name: task.item.name,
      unitFeature: task.item.feature
    };
    const when = task.criteria.when;
    const start = when.start.date;
    const targetWhen = {
      duration: when.duration,
      start: {
        date: when.start.date
      },
      end: {
        date: when.end.date
      },
    }

    const controller = new ModalController();
    let title = i18n.meetingRooms.schedule.captionPattern;
    title = title.replace("{room}",roomItem.name);
    const modalProps = {
      className: "i-modal-confirm i-modal-schedule",
      title: title,
      cancelLabel: i18n.general.close,
      showOKCancel: true,
      hideOK: true
    };
    const content = (
      <Schedule item={roomItem} start={start} when={targetWhen}
        onBookClicked={selectedWhen => {
          task.bookComponent.setWhen(selectedWhen);
          controller.close();
        }}
      />
    )
    controller.show(modalProps,content);
  }

  static show(item,criteria) {
    let bookComponent;
    const status = {executing: false}
    const i18n = Context.instance.i18n;
    const controller = new ModalController();
    const modalProps = {
      className: "i-modal-confirm",
      title: i18n.meetingRooms.book.newMeeting,
      okLabel: i18n.more.bookWorkspace.confirm,
      showOKCancel: true,
      hideCancel: true,
      closeOnOK: false,
      onOK: () => {
        if (status.executing) return;
        let newCriteria = {};
        let ok = bookComponent.validate(newCriteria)
        if (ok) {
          if (newCriteria.when.end.date <= Date.now()) {
            ok = false;
            ModalController.showMessage(i18n.more.bookWorkspace.pastTime,
              i18n.meetingRooms.book.newMeeting);
          }
        }
        if (ok) {
          status.executing = true;
          Book.bookWorkspace({
            item: item,
            criteria: newCriteria,
            bookComponent: bookComponent,
            controller: controller,
            status: status
          });
        }
      },
      extraButton: (
        <Button key="extraButton" className="i-extra-button"
          onClick={() => {
            let newCriteria = {};
            bookComponent.validate(newCriteria,true);
            Book.scheduleClicked({
              item: item,
              criteria: newCriteria,
              bookComponent: bookComponent,
              controller: controller,
              status: status
            });
          }}
        >{i18n.meetingRooms.schedule.viewSchedule}</Button>
      )
    };
    const content = (
      <Book item={item} criteria={criteria}
        onMount={c => bookComponent = c} />
    )
    controller.show(modalProps,content);
  }
}

/* ------------------------------------------------------------ */

class MeetingBookingConfirmed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false
    };
  }

  _togglePopover = () => {
    this.setState({ popoverOpen: !this.state.popoverOpen });
  }

  render() {
    const i18n = Context.getInstance().i18n;
    const { name, range, unit, fl, orgBy, calendarParams } = this.props;
    const { popoverOpen } = this.state;

    const addToCalendarButton = (
      <button
        className={"i-button"}
        onClick={this._togglePopover}
      >
        {i18n.events.details.addToCalendar}
      </button>
    );
    
    return (
      <div className="i-meeting-confirmation">
        <div className="i-booking-confirmed-body">
          <CheckCircleIcon color="green"/>
          <h1>{i18n.meetingRooms.book.meetingCreated}</h1>
        </div>
        <div className="i-meeting-details">
          <div className="i-text-center"><strong>{name}</strong></div>
          <div className="i--row"><span><ClockIcon /></span><span>{range}</span></div>
          <div className="i--row"><span><PinIcon /></span><span>{unit}<br />{fl}</span></div>
          <div className="i--row"><span><UserIcon /></span><span>{orgBy}</span></div>
          <div className="i-text-center i-separated">
            <CalendarSelector 
              onRequestClose={this._togglePopover}
              open={popoverOpen}
              targetEl={addToCalendarButton}
              params={calendarParams}
            />
          </div>
        </div>
      </div>
    );
  }
}
